// This file should be removed w/ React v15 upgrade / legacy React removal.
window.CORE_BUNDLE_LOADED = true;
require('react/lib/DOMProperty').ID_ATTRIBUTE_NAME = 'data-reactid-wp';



/** WEBPACK FOOTER **
 ** ./apps/core/index.js
 **/